var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.DataView,{attrs:{"tableColumns":_setup.tableColumns,"tableData":_vm.items,"actionButtons":_setup.actionButtons,"titleKey":"documentName"},on:{"sortChanged":event => _setup.emit('sortChanged', event),"loadMore":function($event){return _setup.emit('loadMore')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }